import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { Modal, ModalProps } from '@shared/ui/organisms';
import { Text } from '@shared/ui/atoms';
import { CrossIcon } from '@shared/assets/icons';
import { withTheme } from '@shared/lib/theme';
import { usePartner } from '@shared/lib/partner';
import { getMobileMoreModalNavbarItemsByPartner } from '../config/navbarItems';
import MoreModalItem from './MoreModalItem';
import { useActiveNavbarElement } from '../lib/useActiveNavbarElement';
type MoreModalProps = ModalProps;
const MoreModal: FC<MoreModalProps> = ({
  open,
  onClose,
  ...rest
}) => {
  const activeNavbarElement = useActiveNavbarElement();
  const {
    partner
  } = usePartner();
  return <Modal mobile open={open} onClose={onClose} {...rest}>
      <ContentWrapper>
        <TopSection>
          <Text family="MTSCompact" size="pL" weight="medium" color="primary">
            Ещё
          </Text>
          <IconButtonWrapper onClick={onClose}>
            <CrossIcon />
          </IconButtonWrapper>
        </TopSection>
        <ItemsWrapper>
          {getMobileMoreModalNavbarItemsByPartner(partner).map(item => <MoreModalItem key={item.label} isActive={item.href === activeNavbarElement?.href} item={item} onClick={onClose} />)}
        </ItemsWrapper>
      </ContentWrapper>
    </Modal>;
};
export default MoreModal;
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1ozbjve",
  propsAsIs: false
});
const TopSection = /*#__PURE__*/styled('div')({
  name: "TopSection",
  class: "t20n2m4",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.primary;
const IconButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "IconButtonWrapper",
  class: "iqwe4ga",
  propsAsIs: false,
  vars: {
    "iqwe4ga-0": [_exp()]
  }
}));
const ItemsWrapper = /*#__PURE__*/styled('ul')({
  name: "ItemsWrapper",
  class: "ix9trd0",
  propsAsIs: false
});

require("./MoreModal.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./MoreModal.tsx");